<template>
  <div class="content" v-loading="loading">
    <ListButton
    :buttonObj="buttonObj"
      @create="handleCreate"
    >
    </ListButton>
    <el-row>
   <Table
        :props="table.props"
        ref="table"
        :header="table.header"
        :data="table.data"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <el-dialog
  title="预览"
  :visible.sync="dialogPicVisible"
  width="70%"
  >
 <el-image :src="showTablePic"></el-image>
</el-dialog>
  </div>
</template>
<script>
import ListButton from '@/components/ListButton'
export default {
  components: {
    ListButton
  },
  props: {
    searchParams: {
      type: Object,
      default: () => {

      }
    }
  },
  data() {
    return {
      dialogPicVisible: false,
      showTablePic: undefined,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      buttonObj: {
        title: '物料',
        permissionData: 'schedule:add'
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '物料ID',
            align: 'left',
            prop: 'materialId',
            'min-width': 50,
            'show-overflow-tooltip': true
          },
          {
            label: '物料名称',
            align: 'left',
            prop: 'materialName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpace.spaceName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '物料分辨率',
            align: 'left',
            prop: 'resolution',
            'min-width': 80,
            'show-overflow-tooltip': true
          },
          {
            label: '物料大小',
            align: 'left',
            prop: 'size',
            'min-width': 80,
            'show-overflow-tooltip': true,
            formatter: params => {
              return parseFloat(params.size / 1024 / 1024).toFixed(2) + ' M'
            }
          },
          {
            label: '缩略图',
            align: 'left',
            prop: 'materialIcon',
            'min-width': 100,
            render: (h, { row }) => {
              return h('div', {
                style: {
                  width: '50px'
                },
                on: {
                  click: event => {
                    event.stopPropagation()
                    this.handleShow(row.materialIcon)
                  }
                }
              }, [
                h('el-image', {
                  attrs: {
                    src: row.materialIcon
                  },
                  props: {
                    lazy: true
                  },
                  style: {
                    'max-width': '100%',
                    cursor: 'pointer'
                  }

                })
              ])
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            fixed: 'right',
            'show-overflow-tooltip': true,
            'min-width': 150,
            formatter: params => {
              return this.$moment(params.createTime).format('YYYY-MM-DD H:mm:ss')
            }
          },
          {
            label: '操作栏',
            align: 'left',
            'min-width': 100,
            fixed: 'right',
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleDownload(row)
                      }
                    }
                    // directives: [{
                    //   name: 'permission',
                    //   value: 'schedule:edit'
                    // }]
                  },
                  '下载'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleDelete(row)
                      }
                    }
                    // directives: [{
                    //   name: 'permission',
                    //   value: 'schedule:dataOne'
                    // }]
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      }
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pageSize, this.currentPage]
      const filter = { pageSize, pageNo, ...this.searchParams }
      this.$service.getMeidiaFactoryList(filter).then(data => {
        this.loading = false
        this.table.data = data.rows || []
        this.totalCount = data.total || 0
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    handleCreate() {
      this.$emit('create', true)
    },
    handleDownload(row) {
      const a = document.createElement('a')
      a.href = row.materialUrl
      a.target = '_self'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleDelete(row) {
      this.$confirm('确定删除此物料吗？', '提示', {
        showClose: false,
        center: true
      }).then(() => {
        this.$service.deleteMaterial([row.materialId]).then(res => {
          this.fetchData()
        })
      })
    },
    handleShow(e) {
      this.showTablePic = e
      this.dialogPicVisible = true
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
</style>
